// @flow
import { all } from 'redux-saga/effects';

import authSaga from './auth/saga';
import contactosSaga from './contactos/saga';
import mantenimientosSaga from './mantenimientos/saga';
import invoicesSaga from './invoices/saga';
import estimatesSaga from './estimates/saga';
import productosSaga from './productos/saga';
import contratosSaga from './contratos/saga';
import layoutSaga from './layout/saga';
import clientesSaga from './clients/saga';
import oficinasSaga from './oficinas/saga';
import usersSaga from './users/saga';
import employeesSaga from './staff/saga';
import staffProfilesSaga from './staff-profiles/saga';
import erightsSaga from './erights/saga';
import logsSaga from './logs/saga';
import configurationSaga from './configuration/saga';
import languagesSaga from './languages/saga';
import incidenciasSaga from './incidencias/saga';
import tiposSaga from './tipo-incidencias/saga';
import prioridadesSaga from './prioridad-incidencias/saga';
import imagesSaga from './images/saga';
import rolesSaga from './roles/saga';
import printConfSaga from './print-conf/saga';
import privacyPolicySaga from './privacy-policy/saga';
import formulariosInternosSaga from './formularios-internos/saga';
import noticiasSaga from './noticias/saga';
import tiposNoticiaSaga from './tipos-noticia/saga';
import seccionesSaga from './secciones/saga';
import uneTypesSaga from './une-types/saga';
import serviciosSaga from './servicios/saga';
import eventosSaga from './eventos/saga';
import redesSaga from './redes/saga';
import certificacionesSaga from './certificaciones/saga';
import documentosSaga from './documentos/saga';
import categoriasSaga from './categorias/saga';
import puntosInteresSaga from './puntos-interes/saga';
import categoriasPOISaga from './categoriasPOI/saga';
import enlacesSaga from './enlaces/saga';
import demandasSaga from './demandas/saga';
import categoriasEnlacesSaga from './categorias-enlaces/saga';
import mediosSaga from './medios/saga';
import confRegistroSaga from './confRegistro/saga'
import tiposVisitanteSaga from './tipos-visitante/saga';
import tiposSolicitanteSaga from './tipos-solicitante/saga';
import rangosSaga from './rangos-edad/saga';
import procedenciasSaga from './procedencias/saga';
import registrosSaga from './registros/saga';
import destinosSaga from './destinos/saga';
import itSendStatsSaga from './infotools-send-stats/saga';
import estadisticasInfotoolsSaga from './estadisticas-infotools/saga';
import chatSaga from './chat/saga';
import surveySaga from './survey/saga';
import periodSurveySaga from './period-survey/saga';
import mediaSurveySaga from './media-survey/saga';
import questionSurveySaga from './question-survey/saga';
import questionTypeSaga from './question-type/saga';
import optionAnswerSaga from './option-answer/saga';
import instanceSurveySaga from './instance-survey/saga';
import confSurveySaga from './confSurvey/saga';
import DashboardSaga from './dashboard/saga';
import FavOriginsSaga from './favOrigins/saga';
import QRConfSaga from './qr-conf/saga';
import rutasSaga from './rutas/saga'
import categoriasRutaSaga from './categorias-ruta/saga';
import travelsSaga from './travels/saga';
import categoriesTravelSaga from './category-travel/saga';
import eventsContactsSaga from './events-contacts/saga';
import groupsContactsSaga from './groups-contacts/saga';
import typesContactsSaga from './types-contacts/saga';
import otherDataContactsSaga from './other-data-contacts/saga';
import activitiesSaga from './activities/saga';
import personsSaga from './persons/saga'
import contactsSaga from './contacts/saga'
import categoryExperiencesSaga from './category-experiences/saga';
import experiencesSaga from './experiences/saga';
import accommodationsSaga from './accommodations/saga';
import confOpinometroSaga from './confOpinometro/saga';
import instanceOpinometroSaga from './instance-opinometro/saga';
import opinometroSaga from './opinometro/saga';
import optionAnswersOpinometroSaga from './option-answer-opinometro/saga';
import questionOpinometroSaga from './question-opinometro/saga';
import questionTypesOpinometroSaga from './question-type-opinometro/saga';
import devicesSaga from './devices/saga';
import structureItemsSaga from './structure-items/saga';
import translationAiSaga from './translation-ai/saga';
import writesonicSaga from './writesonic/saga';
import instancesInternalFormsSaga from './instances-internal-forms/saga';
import seaConfigSaga from './sea-config/saga';
import seaFlagsSaga from './sea-flags/saga';
import seaLogsSaga from './sea-logs/saga';
import configInfotoolsSaga from './config-infotools/saga';
import modulesInfotoolsSaga from './modules-infotools/saga';
import usersInfotoolsSaga from './users-infotools/saga';

import devicesGroupsSaga from './devices-groups/saga';

export default function* rootSaga(): any {
    yield all(
        [
            authSaga(), 
            layoutSaga(),
            mantenimientosSaga(),
            invoicesSaga(),
            estimatesSaga(),
            productosSaga(),
            contratosSaga(),
            contactosSaga(),
            clientesSaga(),
            oficinasSaga(),
            usersSaga(),
            serviciosSaga(),
            employeesSaga(),
            staffProfilesSaga(),
            erightsSaga(),
            logsSaga(),
            configurationSaga(),
            languagesSaga(),
            incidenciasSaga(),
            tiposSaga(),
            prioridadesSaga(),
            imagesSaga(),
            rolesSaga(),
            printConfSaga(),
            privacyPolicySaga(),
            formulariosInternosSaga(),
            noticiasSaga(),
            tiposNoticiaSaga(),
            seccionesSaga(),
            uneTypesSaga(),
            eventosSaga(),
            redesSaga(),
            certificacionesSaga(),
            documentosSaga(),
            categoriasSaga(),
            categoriasPOISaga(),
            puntosInteresSaga(),
            enlacesSaga(),
            demandasSaga(),
            categoriasEnlacesSaga(),
            mediosSaga(),
            confRegistroSaga(),
            tiposVisitanteSaga(),
            tiposSolicitanteSaga(),
            rangosSaga(),
            procedenciasSaga(),
            registrosSaga(),
            destinosSaga(),
            itSendStatsSaga(),
            estadisticasInfotoolsSaga(),
            chatSaga(),
            surveySaga(),
            periodSurveySaga(),
            mediaSurveySaga(),
            questionSurveySaga(),
            questionTypeSaga(),
            optionAnswerSaga(),
            instanceSurveySaga(),
            confSurveySaga(),
            DashboardSaga(),
            FavOriginsSaga(),
            QRConfSaga(),
            rutasSaga(),
            categoriasRutaSaga(),
            travelsSaga(),
            categoriesTravelSaga(),
            eventsContactsSaga(),
            groupsContactsSaga(),
            typesContactsSaga(),
            otherDataContactsSaga(),
            activitiesSaga(),
            personsSaga(),
            contactsSaga(),
            categoryExperiencesSaga(),
            experiencesSaga(),
            accommodationsSaga(),
            confOpinometroSaga(),
            instanceOpinometroSaga(),
            opinometroSaga(),
            optionAnswersOpinometroSaga(),
            questionOpinometroSaga(),
            questionTypesOpinometroSaga(),
            devicesSaga(),
            devicesGroupsSaga(),
            structureItemsSaga(),
            translationAiSaga(),
            writesonicSaga(),
            instancesInternalFormsSaga(),
            seaConfigSaga(),
            seaFlagsSaga(),
            seaLogsSaga(),
            configInfotoolsSaga(),
            modulesInfotoolsSaga(),
            usersInfotoolsSaga()
        ]
    );
}
